import React from "react";

export const NotFound = () => {
  return (
    <div>
      <h1 style={{ textAlign: "center" }}>Not Found</h1>
    </div>
  );
};
